// extracted by mini-css-extract-plugin
module.exports = {"navigationHomeMobile":"styles_navigationHomeMobile__IRfYW","cardNavigation":"styles_cardNavigation__EQCf7","divisor":"styles_divisor__G9ZRX"};